import type {
  LC_FilteredEmployeeItem,
  LC_GetEmployeesFilteredOut,
  FilteredEmployee,
  FilteredEmployeesPage,
} from '../types/employeeFiltered.types';


export function mapFilteredEmployee(item: LC_FilteredEmployeeItem): FilteredEmployee {
  return {
    employeeId: item.employeeId,
    displayName: item.displayName,
  };
}

export function mapFilteredEmployeesPage(data: LC_GetEmployeesFilteredOut): FilteredEmployeesPage {
  const items = data.data ?? [];
  const { pagination } = data;

  return {
    items: items.map(mapFilteredEmployee),
    pagination: {
      currentPage: pagination.currentPage,
      pageSize: pagination.pageSize,
      totalRecords: pagination.totalRecords,
      totalPages: pagination.totalPages,
      hasPreviousPage: pagination.hasPreviousPage,
      hasNextPage: pagination.hasNextPage,
    },
    validatedSelection: data.validatedSelection ?? [],
  };
}
